import { render } from "./CheckboxRounded.vue?vue&type=template&id=44e80b1f&scoped=true"
import script from "./CheckboxRounded.vue?vue&type=script&lang=js"
export * from "./CheckboxRounded.vue?vue&type=script&lang=js"

import "./CheckboxRounded.vue?vue&type=style&index=0&id=44e80b1f&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e80b1f"]])

export default __exports__